import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CheckBoxInput, {
  SerivceProviderDropdown,
} from "../../../../components/ui_comps/CheckBoxInput";
import CustomSelect from "../../../../components/main_comps/custom_select";
import ComissionContainer, {
  checkObjHasAllValue,
} from "../../../../components/ui_comps/ComissionContainer";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { modififyDropdownServiceNameList } from "../../../../../services/fetchDropdownListData";
import {
  FLAT,
  RESELLER,
  RUPEES,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import {
  SS_ADMIN_ID,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { colorWhite } from "../../../../../utility/constants/colorManager";
import { clearGlobalFilterReducer } from "../../../../../data/redux/slice/globalFiltersSlice";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false,
  defaultChecked2,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
        defaultChecked2={defaultChecked2}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

const Service = ({
  onClickNext,
  onClickPrevious,
  onClickCancel,
  clientDetails,
}) => {
  const [currentValue, setCurrentValue] = useState("Flat");
  const [serviceType, setServiceType] = useState(RUPEES);
  const [serviceProviderRate, setServiceProviderRate] = useState("");
  const [reseller, setReseller] = useState("");
  const [resellerRate, setResellerRate] = useState("");
  const [neokredRate, setNeokredRate] = useState("");
  const [clientRate, setClientRate] = useState([]);
  const [resellerName, setResellerName] = useState("");
  const [resellerData, setResellerData] = useState([]);
  const [createdBy, setCreatedBy] = useState({});
  const [adminId, setAdminId] = useState("");
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [flatData, setFlatData] = useState({});
  const [type, setType] = useState("");
  // const [payinServiceList, setPayinServiceList] = useState({});
  // const [payoutServiceList, setPayoutServiceList] = useState({});
  const [mechanism, setMechanism] = useState([]);
  const [prefillComissionRate, setPrefillCommissionRate] = useState([]);
  const [notifyUrl, setNotifyUrl] = useState("");
  const [validateUrl, setValidateUrl] = useState("");
  const [zyromechanism, setZyroMechanism] = useState("cba");
  const [zyroUserId, setZyroUserId] = useState("");
  const [zyroPassword, setZyroPassword] = useState("");
  const [mechanism2, setMechanism2] = useState(["cba"]);
  const [cid, setCid] = useState("");
  const [sid, setSid] = useState("");
  const [upi, setUpi] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const reduxData = useSelector((state) => state.addService);
  const [vpaSubString, setVpaSubString] = useState("");
  const [mccCode, setMcccode] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const [merchantApiKey, setMerchantApiKey] = useState("");
  const [onDemandSettlement, setOnDemandSettlement] = useState(false);
  const [settleToAccount, setSettleToAccount] = useState(false);
  const [isInternal, setIsInternal] = useState(false);
  const [voucherServiceType, setVoucherServiceType] = useState("");

  const inputStyle = {
    maxWidth: 500,
    minWidth: 250,
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    width: 350,
  };
  const containerStyle = {
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: 40,
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };

  const containerStyle1 = {
    left: "calc(50% - 343px/2)",
    top: "24px",
    paddingLeft: "10px",
  };

  const getData = async () => {
    const id = await secureStorage.getItem(SS_USER_HASH_ID);
    const role = await secureStorage.getItem(SS_ROLE);
    const firstName = await secureStorage.getItem(SS_FIRST_NAME);
    const lastName = await secureStorage.getItem(SS_LAST_NAME);
    const email = await secureStorage.getItem(SS_EMAIL);
    const adminid = await secureStorage.getItem(SS_ADMIN_ID);

    setCreatedBy({ email, userName: firstName + " " + lastName });

    if (role?.toLocaleUpperCase() === RESELLER) {
      setResellerName(firstName + " " + lastName);
      setAdminId(adminid);
    }
    setUserId(id);
    setRole(role);
  };

  const getResellerList = () => {
    ApiRequestGet.getResellerList()
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setResellerData(modififyDropdownData(res.data));
        }
      })
      .catch((err) => {});
  };
  const modififyDropdownData = (data) => {
    let arr = [
      {
        label: "Select Reseller",
        value: "",
        commissionRate: "",
        commissionType: "",
        userRefId: "",
      },
    ];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.userId,
          label: val.firstName + " " + val.lastName,
          commissionRate: val?.comissionRate,
          commissionType: val?.comissionType,
          userRefId: val?.userRefId,
        });
      });

    return arr;
  };
  useEffect(() => {
    getData();
    getResellerList();
  }, []);

  useEffect(() => {
    console.log(reduxData, "REDUX DATA");
  }, [reduxData]);

  useEffect(() => {
    let service_provider =
      reduxData?.service?.serviceProviderName?.toUpperCase();
    let service_type = reduxData?.service?.serviceType?.toUpperCase();

    if (reduxData?.service?.serviceProviderRate) {
      setServiceProviderRate(reduxData?.service?.serviceProviderRate);
    }
    if (
      (reduxData?.service?.serviceProviderRate &&
        reduxData?.service?.resellerRate &&
        reduxData?.service?.neokredRate &&
        reduxData?.service?.comissionRate &&
        reduxData?.service?.comissionType &&
        reduxData?.service?.notifyUrl) ||
      reduxData?.service?.validateUrl
    ) {
      setCurrentValue(reduxData?.service?.comissionType);
      setType(reduxData?.service?.comissionType);
      setServiceProviderRate(reduxData?.service?.serviceProviderRate);
      setReseller({
        label: reduxData?.resellerName,
        value: reduxData?.userRefId,
        userRefId: reduxData?.rootReferenceId,
      });
      setResellerRate(reduxData?.service?.resellerRate);
      setNeokredRate(reduxData?.service?.neokredRate);

      let commissionRate = reduxData?.service?.comissionRate;

      if (reduxData?.service?.comissionType === FLAT) {
        setFlatData(commissionRate[0]);
      } else {
        setClientRate(commissionRate);
      }

      setPrefillCommissionRate(commissionRate);
      setNotifyUrl(reduxData?.service?.notifyUrl);
      //setMechanism(reduxData?.service?.mechansim);
      if (reduxData?.service?.serviceType?.toLowerCase() === "payin") {
        setCid(reduxData?.service?.cid);
        setUpi(reduxData?.service?.upi);
        setSid(reduxData?.service?.sid);
        let temp = [];
        temp.push(reduxData?.service?.mechanism);

        setMechanism(temp[0]);
      }

      if (
        reduxData?.service?.mechanism.includes("cba") &&
        reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO"
      ) {
        setZyroMechanism("cba");
        let temp = [];
        temp.push("cba");
        setMechanism2(temp);
      }
      if (
        reduxData?.service?.mechanism.includes("van") &&
        reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO"
      ) {
        setZyroMechanism("van");
        let temp = [];
        temp.push("van");
        setMechanism2(temp);
        setZyroUserId(reduxData?.service?.zyroUserId);
        setZyroPassword(reduxData?.service?.zyroPassword);
      }
    }
    if (service_provider === "1PAY") {
      setMerchantId(reduxData?.service?.merchantId);
      setMerchantApiKey(reduxData?.service?.merchantApiKey);
    }
    if (
      service_provider === "1PAY" ||
      service_provider === "FINO" ||
      service_provider === "NPST" ||
      service_provider === "EQUITAS"
    ) {
      setMcccode(reduxData?.service?.mcc);
      setVpaSubString(reduxData?.service?.vpaSubString);
    }

    if (service_type === "VAN" && service_provider === "EQUITAS") {
      setIsInternal(reduxData?.service?.internal);
    }
    if (
      service_type === "VAN" ||
      (service_type === "VAN-UPI" &&
        (service_provider === "AXIS" ||
          service_provider === "IDFC" ||
          service_provider === "EQUITAS"))
    ) {
      setValidateUrl(reduxData?.service?.validateUrl);
      setOnDemandSettlement(reduxData?.service?.onDemandSettlement);
      setSettleToAccount(reduxData?.service?.settleToAccount);
    }
    if (service_type === "PAYOUT" && service_provider === "AXIS") {
      if (reduxData?.service?.mechanism?.includes("van")) {
        setZyroMechanism("van");
        let temp = [];
        temp.push("van");
        setMechanism2(temp);
      } else {
        setZyroMechanism("cba");
        let temp = [];
        temp.push("cba");
        setMechanism2(temp);
      }
    }
    if (
      reduxData?.service?.serviceProviderName?.toUpperCase() === "NEOKRED" &&
      reduxData?.service?.serviceType?.toUpperCase() === "VOUCHER"
    ) {
      // console.log("PLESE_SET_BRO ", reduxData.service.program, "WHAT_ISTHIS");
      setVoucherServiceType(reduxData.service.program);
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        marginTop: "20px",
        position: "absolute",
      }}
    >
      <p style={styles.title}>Service Rate</p>
      <p style={styles.p1}>Enter the NK rate</p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C",
        }}
      ></div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "20px 20px 20px 20px",
          gap: 20,
          border: "1px solid #CBCACA",
          borderRadius: "5px",
          backgroundColor: colorWhite,
          marginBottom: 20,
        }}
      >
        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>
            Service Provider Rate
          </label>
          <CustomInput
            value={serviceProviderRate}
            // onChange={(data) => {
            //   setServiceProviderRate(data);
            // }}
            inputcomponentStyles={{ ...inputStyle }}
            disabled={true}
            placeholder="Service Provider Rate"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        {/* <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Reseller</label>
          <CustomSelect
            placeholder="Select Reseller"
            style={{
              ...containerStyle,
              backgroundColor: "white",
              position: "",
            }}
            disabled={true}
            value={reseller}
            options={resellerData}
            onChange={(data) => {
              setReseller(data);
            }}
          />
        </div> */}

        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Reseller Rate</label>
          <CustomInput
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Eg : 20%"
            type="input"
            validator="percentageDecimal"
            inputStyles={{
              ...containerStyle,
            }}
            value={resellerRate}
            onChange={(data) => {
              setResellerRate(data);
            }}
            maxLength={5}
          />
        </div>

        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Neokred Rate</label>
          <CustomInput
            onChange={(data) => {
              setNeokredRate(data);
            }}
            value={neokredRate}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Eg : 30%"
            validator="percentageDecimal"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            maxLength={5}
          />
        </div>

        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Notify Url</label>
          <CustomInput
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Notify Url"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            value={notifyUrl}
            onChange={(data) => {
              setNotifyUrl(data);
            }}
          />
        </div>

        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Client Rate</label>
          <ComissionContainer
            styles={{
              width: "343px",
              background: "white",
              minHeight: "71px",
              borderRadius: "6px",
              border: "1px solid #CBCACA",
            }}
            innerStyles={{
              marginLeft: "-12px",
              marginTop: "-8px",
            }}
            onClickNext={(data, flatData, type) => {
              if (data.length > 0) {
                setClientRate(data);
              }
              if (flatData) {
                setFlatData(flatData);
              }
              if (type) {
                setType(type?.toUpperCase());
              }
            }}
            isSlabRequired={true}
            rate={reduxData?.service?.commissionRate ?? prefillComissionRate}
            type={reduxData?.service?.comissionType ?? type}
            // ex={"PAYIN"}
            slabData={
              // reduxData?.service?.comissionType === "slab" ??
              reduxData?.service?.comissionRate
            }
            onClickDelete={(data) => {
              if (data.length === 0) {
                setClientRate([]);
              }
            }}
          />
        </div>
        {/* adding UPI for IDFC */}
        {reduxData?.service?.serviceProviderName?.toUpperCase() === "KOPAY" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "NPST" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "1PAY" ? (
          <div style={{ marginTop: 20, marginRight: 20 }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>UPI</label>
            <CustomInput
              value={upi}
              onChange={(data) => setUpi(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the UPI ID"
              validator="upi"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
        ) : null}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "1PAY" && (
          <>
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Merchant Id</label>
              <CustomInput
                onChange={(data) => {
                  setMerchantId(data);
                }}
                value={merchantId}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Merchant Id"
                validator="alphaNum2"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Merchant Api Key
              </label>
              <CustomInput
                onChange={(data) => {
                  setMerchantApiKey(data);
                }}
                value={merchantApiKey}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Merchant Api Key"
                validator="alphaNum2"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
          </>
        )}
        {/* complete */}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "FINO" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "NPST" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "1PAY" ||
        reduxData?.service?.serviceType?.toUpperCase() === "VAN-UPI" ||
        (reduxData?.service?.serviceProviderName?.toUpperCase() === "IDFC" &&
          reduxData?.service?.serviceType?.toUpperCase() === "PAYIN") ? (
          <div style={{ minWidth: "150px" }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>MCC code</label>
            <CustomInput
              onChange={(data) => {
                setMcccode(data);
              }}
              value={mccCode}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="MCC code"
              validator="mcc"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
        ) : null}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "FINO" && (
          <>
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Vpa Sub String
              </label>
              <CustomInput
                onChange={(data) => {
                  setVpaSubString(data);
                }}
                value={vpaSubString}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Vpa Substring"
                validator={"alphaNum2"}
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
                maxLength={20}
              />
            </div>
          </>
        )}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "KOPAY" ||
          (reduxData?.service?.serviceProviderName?.toUpperCase() ===
            "NPST" && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ marginTop: 20, marginRight: 20 }}>
                  <label style={{ fontSize: 14, lineHeight: 2 }}>SID</label>
                  <CustomInput
                    value={sid}
                    onChange={(data) => setSid(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Enter the SID"
                    validator="sid"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
              </div>
            </>
          ))}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "KOPAY" && (
          <>
            <div style={{ marginTop: 20, marginRight: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>CID</label>
              <CustomInput
                value={cid}
                onChange={(data) => setCid(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Enter the CID"
                validator="alphaNum"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
          </>
        )}

        {reduxData?.service?.serviceType?.toUpperCase() === "VAN" &&
          (reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "IDFC") && (
            <>
              <div
                style={{
                  maxWidth: "343px",
                  display: "flex",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                <CheckBoxInput
                  title="onDemandSettlement"
                  value={onDemandSettlement}
                  onChange={(event) => {
                    const isChecked = event.target.checked;
                    setOnDemandSettlement(isChecked);
                  }}
                  defaultChecked={onDemandSettlement}
                />
                <CheckBoxInput
                  title="settleToAccount"
                  value={settleToAccount}
                  onChange={(event) => {
                    const isChecked = event.target.checked;
                    setSettleToAccount(isChecked);
                  }}
                  defaultChecked={settleToAccount}
                />
              </div>
            </>
          )}

        {((reduxData?.service?.serviceType?.toUpperCase() === "VAN" &&
          (reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "EQUITAS" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "IDFC")) ||
          reduxData?.service?.serviceType?.toUpperCase() === "VAN-UPI") && (
          <>
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                validate Url
              </label>
              <CustomInput
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="validate Url"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
                value={validateUrl}
                onChange={(data) => {
                  setValidateUrl(data);
                }}
              />
            </div>
          </>
        )}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "EQUITAS" &&
          reduxData?.service?.serviceType?.toUpperCase() === "VAN" && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ marginTop: 20, marginRight: 20 }}>
                  <CheckBoxInput
                    title="Internal"
                    value={isInternal}
                    onChange={(event) => {
                      const isChecked = event.target.checked;
                      setIsInternal(isChecked);
                    }}
                    defaultChecked={isInternal}
                  />
                </div>
              </div>
            </>
          )}

        {/* NEOKRED AND VOUCHER */}
        {reduxData?.service?.serviceProviderName?.toUpperCase() === "NEOKRED" &&
          reduxData?.service?.serviceType?.toUpperCase() === "VOUCHER" && (
            <>
              <div>
                <label
                  htmlFor="program"
                  style={{ fontSize: 14, lineHeight: 2 }}
                >
                  Program
                </label>
                <div
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #CBCACA",
                    width: "343px",
                    background: "white",
                    minHeight: "71px",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      marginTop: 20,
                      gap: 50,
                      marginBottom: "20px",
                    }}
                  >
                    <RadioButton
                      id="fino"
                      name="voucherServiceType"
                      title="Fino"
                      value={voucherServiceType}
                      onChange={() => {
                        setVoucherServiceType("fino");
                      }}
                      defaultChecked={voucherServiceType == "fino"}
                    />
                    <RadioButton
                      id="idfc"
                      name="voucherServiceType"
                      title="Idfc"
                      value={voucherServiceType}
                      onChange={() => {
                        setVoucherServiceType("idfc");
                      }}
                      defaultChecked={voucherServiceType == "idfc"}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

        {(reduxData?.service?.serviceProviderName?.toUpperCase() === "KOPAY" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() === "NPST" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() === "FINO" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() ===
            "1PAY") && (
          <div>
            <div
              style={{
                maxWidth: "343",
                display: "flex",
                marginTop: "10px",
                alignItems: "center",
              }}
            >
              <CheckBoxInput
                title="VBA"
                value={"vba"}
                defaultChecked={mechanism?.includes("vba")}
                onChange={(val) => {
                  if (mechanism?.includes("vba")) {
                    let arr = mechanism?.filter((o) => o !== "vba");
                    setMechanism(arr);
                  } else {
                    setMechanism([...mechanism, val.target.value]);
                  }
                }}
              />
              <CheckBoxInput
                title="QR"
                value={"qr"}
                defaultChecked={mechanism?.includes("qr")}
                onChange={(val) => {
                  if (mechanism?.includes("qr")) {
                    let arr = mechanism?.filter((o) => o !== "qr");
                    setMechanism(arr);
                  } else {
                    setMechanism([...mechanism, val.target.value]);
                  }
                }}
              />
            </div>
          </div>
        )}

        {(reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() === "IDFC") &&
          reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" && (
            <div
              style={{
                display: "flex",
                marginTop: 15,
                gap: 50,
                marginBottom: "20px",
              }}
            >
              <RadioButton
                id="yes"
                name="yes_radio"
                title="Connected Banking"
                value="cba"
                onChange={(val) => {
                  setZyroMechanism(val.target.value);
                  mechanism2.pop();
                  let temp = [];
                  temp.push(val.target.value);
                  setMechanism2(temp);
                  setZyroPassword("");
                  setZyroUserId("");
                }}
                defaultChecked={zyromechanism === "cba"}
              />
              <RadioButton
                id="no"
                name="yes_radio"
                title="Virtual Account"
                value="van"
                onChange={(val) => {
                  setZyroMechanism(val.target.value);
                  mechanism2.pop();
                  let temp = [];
                  temp.push(val.target.value);
                  setMechanism2(temp);
                }}
                defaultChecked={zyromechanism === "van"}
              />
            </div>
          )}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO" &&
          zyromechanism === "van" && (
            <>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>User ID</label>
                <CustomInput
                  onChange={(data) => {
                    setZyroUserId(data);
                  }}
                  value={zyroUserId}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="User ID"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>Password</label>
                <CustomInput
                  onChange={(data) => {
                    setZyroPassword(data);
                  }}
                  value={zyroPassword}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Password"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            </>
          )}
      </div>

      <div
        style={{
          display: "flex",
          marginTop: "20px",
          marginBottom: 20,
        }}
      >
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              const exp = /^\d{1,2}(?:\.\d{1,2})?$/;
              const rupeesRegex = /^\d+(\.\d+)?$/;
              const upiExp = /[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}/;

              let ServiceProvider =
                reduxData?.service?.serviceProviderName?.toUpperCase();
              let servicetype = reduxData?.service?.serviceType?.toUpperCase();

              if (type?.toUpperCase() === "FLAT") {
                if (flatData?.value === "" || flatData?.type === undefined) {
                  enqueueSnackbar("Please fill all fields", {
                    variant: "error",
                  });
                  return;
                }

                if (flatData?.type === "RUPEES") {
                  if (!rupeesRegex.test(flatData?.value)) {
                    enqueueSnackbar("Please add appropriate value", {
                      variant: "error",
                    });
                    return;
                  }
                }
                if (flatData?.type === "PERCENTAGE") {
                  if (!exp.test(flatData?.value)) {
                    enqueueSnackbar("Please add appropriate value", {
                      variant: "error",
                    });
                    return;
                  }
                }
              }

              if (type?.toUpperCase() === "SLAB") {
                if (clientRate.length === 0) {
                  enqueueSnackbar("Please fill all fields", {
                    variant: "error",
                  });
                  return;
                }

                for (const slabValues of clientRate) {
                  if (
                    slabValues?.value === "" ||
                    slabValues?.from === "" ||
                    slabValues?.to === ""
                  ) {
                    enqueueSnackbar("Please fill all fields", {
                      variant: "error",
                    });
                    return;
                  }

                  if (slabValues?.type === "RUPEES") {
                    if (!rupeesRegex.test(slabValues?.value)) {
                      enqueueSnackbar("Please add appropriate value", {
                        variant: "error",
                      });
                      return;
                    }
                  }
                  if (slabValues?.type === "PERCENTAGE") {
                    if (!exp.test(slabValues?.value)) {
                      enqueueSnackbar("Please add appropriate value", {
                        variant: "error",
                      });
                      return;
                    }
                  }
                }
              }

              var neokredRatetest = exp.test(neokredRate);
              var resellerRateTest = exp.test(resellerRate);

              if (!neokredRatetest || !resellerRateTest) {
                enqueueSnackbar("Please Enter Valid rate", {
                  variant: "error",
                });
                return;
              }

              if (ServiceProvider === "KOPAY") {
                if (cid === "" || sid === "") {
                  enqueueSnackbar("Please fill all fields", {
                    variant: "error",
                  });
                  return;
                }
              }
              if (ServiceProvider === "NPST") {
                if (sid === "") {
                  enqueueSnackbar("Please fill all fields", {
                    variant: "error",
                  });
                  return;
                }
              }

              if (
                ServiceProvider === "KOPAY" ||
                ServiceProvider === "1PAY" ||
                ServiceProvider === "NPST"
              ) {
                if (!upiExp.test(upi)) {
                  enqueueSnackbar("Please provide valid upi", {
                    variant: "error",
                  });
                  return;
                }
              }
              if (
                ServiceProvider === "FINO" ||
                ServiceProvider === "KOPAY" ||
                ServiceProvider === "1PAY" ||
                ServiceProvider === "NPST"
              ) {
                if (mechanism.length === 0 || mechanism.length > 1) {
                  enqueueSnackbar("Please select  one Mechanism", {
                    variant: "error",
                  });
                  return;
                }
              }

              if (
                ServiceProvider === "FINO" ||
                ServiceProvider === "1PAY" ||
                ServiceProvider === "NPST" ||
                servicetype === "VAN-UPI" ||
                (ServiceProvider === "IDFC" &&
                  reduxData?.service?.serviceType === "PAYIN")
              ) {
                if (mccCode === undefined || mccCode.length < 4) {
                  enqueueSnackbar("Please Enter valid MCC", {
                    variant: "error",
                  });
                  return;
                }
              }

              if (ServiceProvider === "FINO") {
                if (vpaSubString === undefined || vpaSubString.length === 0) {
                  enqueueSnackbar("Please Enter valid vpaSubString ", {
                    variant: "error",
                  });
                  return;
                }
                if (mccCode === undefined || mccCode.length < 4) {
                  enqueueSnackbar("Please Enter valid MCC", {
                    variant: "error",
                  });
                  return;
                }
              }
              if (ServiceProvider === "IDFC" && servicetype === "PAYIN") {
                if (mccCode === undefined || mccCode.length < 4) {
                  enqueueSnackbar("Please Enter valid MCC", {
                    variant: "error",
                  });
                  return;
                }
              }
              if (ServiceProvider === "NEOKRED" && servicetype === "VOUCHER") {
                if (!voucherServiceType) {
                  enqueueSnackbar("Please Select the Voucher Program", {
                    variant: "error",
                  });
                  return;
                }
              }

              if (ServiceProvider === "1PAY") {
                if (merchantId === undefined || merchantId.length === 0) {
                  enqueueSnackbar("Please Enter Merchant Id ", {
                    variant: "error",
                  });
                  return;
                }
                if (
                  merchantApiKey === undefined ||
                  merchantApiKey.length === 0
                ) {
                  enqueueSnackbar("Please Enter Merchant Api Key ", {
                    variant: "error",
                  });
                  return;
                }
              }

              if (settleToAccount && onDemandSettlement) {
                enqueueSnackbar("Please Select one  settlement ", {
                  variant: "error",
                });
                return;
              }

              if (
                type !== "" &&
                serviceType !== "" &&
                serviceProviderRate !== "" &&
                resellerRate !== "" &&
                neokredRate !== "" &&
                clientRate !== ""
              ) {
                let obj = [];

                if (type === "FLAT") {
                  obj.push(flatData);
                }

                let arr = [];
                arr.push("vac");
                let array = [];
                array.push("van");

                let mechanismValue;
                if (ServiceProvider === "KOPAY") {
                  mechanismValue = mechanism;
                } else if (
                  servicetype === "PAYOUT" &&
                  (ServiceProvider === "ZYRO" ||
                    ServiceProvider === "AXIS" ||
                    ServiceProvider === "IDFC")
                ) {
                  mechanismValue = mechanism2;
                } else if (
                  servicetype === "VAN" &&
                  (ServiceProvider === "AXIS" ||
                    ServiceProvider === "IDFC" ||
                    ServiceProvider === "EQUITAS")
                ) {
                  mechanismValue = array;
                } else if (
                  servicetype === "PAYIN" &&
                  ServiceProvider === "IDFC"
                ) {
                  let mech = [];
                  mech.push("qr");
                  mechanismValue = mech;
                } else if (
                  servicetype === "VOUCHER" &&
                  ServiceProvider === "NEOKRED"
                ) {
                  let mech = [];
                  mech.push("coupon");
                  mechanismValue = mech;
                } else {
                  mechanismValue = "";
                }

                let obj1 = {
                  resellerRate: resellerRate,
                  neokredRate: neokredRate,
                  mechanism: mechanismValue ?? "",
                  // ServiceProvider === "KOPAY"
                  //   ? mechanism
                  //   : ServiceProvider === "ZYRO" || ServiceProvider === "AXIS"
                  //   ? mechanism2
                  //   ? servicetype==="VAN" && ServiceProvider==="AXIS" ?arr:"",
                  comissionType: type,
                  comissionRate: type === "FLAT" ? [flatData] : clientRate,
                  serviceProviderRate: reduxData?.service?.serviceProviderRate,
                  serviceType: reduxData?.service?.serviceType,
                  serviceProviderName: reduxData?.service?.serviceProviderName,
                  notifyUrl: notifyUrl ?? "",
                  zyroUserId: ServiceProvider === "ZYRO" ? zyroUserId : "",
                  zyroPassword: ServiceProvider === "ZYRO" ? zyroPassword : "",
                  validateUrl: validateUrl ? validateUrl : "",
                  mcc: servicetype === "VAN-UPI" ? mccCode : "",
                  program:
                    ServiceProvider === "NEOKRED" ? voucherServiceType : "",
                };

                let obj2 = {
                  resellerRate: resellerRate,
                  neokredRate: neokredRate,
                  mechanism:
                    ServiceProvider === "KOPAY" ||
                    ServiceProvider === "FINO" ||
                    ServiceProvider === "NPST" ||
                    ServiceProvider === "1PAY"
                      ? mechanism
                      : ServiceProvider === "IDFC" && servicetype === "PAYIN"
                      ? ["qr"]
                      : ServiceProvider === "ZYRO"
                      ? mechanism2
                      : "",
                  comissionType: type,
                  comissionRate: type === "FLAT" ? [flatData] : clientRate,
                  serviceProviderRate: reduxData?.service?.serviceProviderRate,
                  serviceType: reduxData?.service?.serviceType,
                  serviceProviderName: reduxData?.service?.serviceProviderName,
                  notifyUrl: notifyUrl,
                  cid: cid,
                  sid: sid,
                  upi:
                    ServiceProvider === "IDFC" && servicetype === "PAYIN"
                      ? "gifton@idfcacq"
                      : upi,
                  mcc:
                    ServiceProvider === "FINO" ||
                    ServiceProvider === "1PAY" ||
                    ServiceProvider === "NPST" ||
                    servicetype === "VAN-UPI" ||
                    (ServiceProvider === "IDFC" && servicetype === "PAYIN")
                      ? mccCode
                      : "",
                  vpaSubString: ServiceProvider === "FINO" ? vpaSubString : "",
                };

                if (
                  servicetype === "VAN" &&
                  (ServiceProvider === "AXIS" || ServiceProvider === "IDFC")
                ) {
                  obj1.onDemandSettlement = onDemandSettlement;
                  obj1.settleToAccount = settleToAccount;
                }
                if (servicetype === "VAN" && ServiceProvider === "EQUITAS") {
                  obj1.internal = isInternal;
                }
                if (ServiceProvider === "1PAY") {
                  obj2.merchantId = merchantId;
                  obj2.merchantApiKey = merchantApiKey;
                }

                if (ServiceProvider === "ZYRO") {
                  if (obj1?.mechanism.includes("van")) {
                    if (zyroUserId === "" || zyroPassword === "") {
                      enqueueSnackbar("Please fill all fields", {
                        variant: "error",
                      });
                      return;
                    }
                  }
                }

                onClickNext({
                  service:
                    ServiceProvider === "KOPAY" ||
                    ServiceProvider === "FINO" ||
                    ServiceProvider === "1PAY" ||
                    ServiceProvider === "NPST" ||
                    (ServiceProvider === "IDFC" && servicetype === "PAYIN")
                      ? obj2
                      : obj1,
                });
              } else {
                enqueueSnackbar("Please fill all the fields ", {
                  variant: "error",
                });
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Service;

const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content",
  },
  p: {
    color: "#6C6B6B",
    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
  select: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#001053",
  },
};
